/**
 * Created by Jerker Nord on 2019-03-12.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {ThorGameConfig} from "../../ThorGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {AnimatedMeshRope} from "../../bezieranimation/AnimatedMeshRope";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite} from "gsap";
import {TextureHelper} from "../../bezieranimation/TextureHelper";

export class ThorAnimatedWinlinesView extends BaseView {

    private _layer:ScalableLayer;
    private _betLinesData:number[][];
    private _winLines:AnimatedMeshRope[];
    private _winLinesAdded:number[];
    private _fixedTextures:PIXI.Texture[];
    private _initAnimations:boolean = false;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.BIG_WIN.name);
        this._layer.addChild(this);
        this._winLines = [];
        this._winLinesAdded = [];
    }

    protected initAnimations():void {
        this._initAnimations = true;
        this._fixedTextures = TextureHelper.removeBaseTextures(GameResources.getTextures("winEnergy"));
        if(this._betLinesData) {
            this.createWinLines();
        }
    }

    private createWinLines():void {
        for(let i:number = 0; i < this._betLinesData.length; i++) {
            let curvePoints:number[][] = [];
            for(let j:number = 0; j < this._betLinesData[i].length; j++) {
                curvePoints.push(Helper.getSymbolPositions(j, this._betLinesData[i][j]));

                // Add extra curve point to extend line to the right at the end
                if(j == (this._betLinesData[i].length - 1)) {
                    curvePoints.push(Helper.getSymbolPositions(j, this._betLinesData[i][j]));
                    curvePoints[curvePoints.length - 1][0] += 85;
                }
            }

            this.createWinLine(curvePoints);
        }
    }

    private createWinLine(curvePoints:number[][]):void {
        const animatedMeshRope:AnimatedMeshRope = new AnimatedMeshRope();
        animatedMeshRope.createAnimatedMeshRope(this._fixedTextures, curvePoints);
        this._winLines.push(animatedMeshRope);
    }

    public getWinlineTL(winLine:number):TimelineLite {
        const winLineTL:TimelineLite = new TimelineLite({});
        if(this._winLinesAdded.indexOf(winLine) == -1) {
            this._winLinesAdded.push(winLine);
            winLineTL.add(() => (this.addChild(this._winLines[winLine])));
        }
        winLineTL.add(() => (this._winLines[winLine].getAnimatedMeshRopeTL()));
        return winLineTL;
    }

    public getCleanUpWinlinesTL():TimelineLite {
        const cleanUpWinLinesTL:TimelineLite = new TimelineLite({});
        cleanUpWinLinesTL.add(() => (this.removeChildren()));
        cleanUpWinLinesTL.add(() => (this._winLinesAdded = []));
        return cleanUpWinLinesTL;
    }

    set betLinesData(value:number[][]) {
        this._betLinesData = value;
        if(this._initAnimations == true && this._winLines.length == 0) {
            this.createWinLines();
        }
    }
}